import { createSlice } from "@reduxjs/toolkit";

export const userId = createSlice({
    name: 'userid',
    initialState: {
        value: '',
        privilege: '',
        templateTab: '',
        specialTab: false,
        userName: '',
        email: '',
        internalSource: false
    },
    reducers: {
        updateUserId: (state, action) => {
            state.value = action.payload
        },
        updatePrivilege: (state, action) => {
            state.privilege = action.payload
        },
        updateTemplateTab: (state, action) => {
            state.templateTab = action.payload
        },
        updateSpecialTab: (state, action) => {
            state.specialTab = action.payload
        },
        updateUserName: (state, action) => {
            state.userName = action.payload
        },
        updateUserEmail: (state, action) => {
            state.email = action.payload
        },
        updateInternalSource: (state, action) => {
            state.internalSource = action.payload
        }
    }
})

export const selectUuid = (state) => state.userid.value
export const getUserPrivilege = (state) => state.userid.privilege
export const getTemplateTab = (state) => state.userid.templateTab
export const getSpecialTab = (state) => state.userid.specialTab
export const getUserName = (state) => state.userid.userName
export const getUserEmail = (state) => state.userid.email
export const getUserInternalSource = (state) => state.userid.internalSource

export const { updateUserId, updatePrivilege, updateTemplateTab, updateSpecialTab, updateUserName, updateUserEmail, updateInternalSource } = userId.actions

export default userId.reducer